/* apps/viewer/src/app/toc-items/comments-module/comment-list/comment-list.component.scss */
:host {
  align-self: center;
  max-width: 900px;
  width: 100%;
}
:host .mat-mdc-table {
  margin-top: 10px;
}
:host ::ng-deep .mat-mdc-table {
  background: inherit !important;
}
:host ::ng-deep mat-table > .mat-mdc-cell {
  overflow: auto;
}
:host ::ng-deep mat-header-row {
  display: none;
}
:host ::ng-deep mat-row {
  border: none;
}
:host ::ng-deep mat-cell {
  border-bottom: none;
  overflow: unset;
}
:host ::ng-deep o-note {
  width: 100%;
}
.empty-message {
  display: flex;
  justify-content: center;
}
.comment-container {
  align-items: center;
  display: flex;
}
.select-expand-actions {
  align-items: center;
  display: flex;
  padding: 0 34px 10px;
}
.button-icon {
  background: transparent;
  border: none;
}
.collapse-all-btn,
.select-all-btn {
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
}
.select-all-btn {
  margin-right: 15px;
}
#import-comments-input {
  display: none;
}
::ng-deep .comment-export-menu {
  max-width: fit-content;
}
.hide {
  visibility: hidden;
}
@media print {
  mat-checkbox {
    display: none;
  }
  o-comment {
    page-break-inside: avoid;
  }
}
/*# sourceMappingURL=comment-list.component.css.map */
